import React from 'react';

const BarGraph = ({ fill = '' }: { fill?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.40039 0.800781H4.00039C4.21256 0.800781 4.41605 0.885067 4.56608 1.0351C4.7161 1.18512 4.80039 1.38861 4.80039 1.60078V15.1944H1.60039V1.60078C1.60039 1.38861 1.68468 1.18512 1.8347 1.0351C1.98473 0.885067 2.18822 0.800781 2.40039 0.800781ZM7.20039 5.60078H8.80039C9.01256 5.60078 9.21605 5.68507 9.36608 5.8351C9.5161 5.98513 9.60039 6.18861 9.60039 6.40078V15.1944H6.40039V6.40078C6.40039 6.18861 6.48468 5.98513 6.63471 5.8351C6.78473 5.68507 6.98822 5.60078 7.20039 5.60078ZM12.0004 10.4008H13.6004C13.8126 10.4008 14.016 10.4851 14.1661 10.6351C14.3161 10.7851 14.4004 10.9886 14.4004 11.2008V15.1944H11.2004V11.2008C11.2004 10.9886 11.2847 10.7851 11.4347 10.6351C11.5847 10.4851 11.7882 10.4008 12.0004 10.4008Z"
      fill={fill || 'var(--PRIMARY)'}
    />
  </svg>
);

export default BarGraph;
